import {
  BodyText,
  breakpoint,
  ButtonRow,
  TertiaryButton,
} from '@grays-npm/component-library';
import styled from 'styled-components';
import { Modal, ModalProps, LoadingButton } from '../../../components';
import { useCMSData } from '../../../state/content-manager';

type HoldReserveModalProps = Omit<ModalProps, 'title'> & {
  onAcceptBidLink: () => void;
  onHoldReserve: () => void;
};

const PrimaryText = styled(BodyText)`
  margin: 0 0 ${({ theme }) => theme.spacings[4].rem};

  ${breakpoint('sm')`
    margin: ${({ theme: { spacings } }) =>
      `0 ${spacings[5].rem} ${spacings[4].rem} 0`};
  `}
`;

const SecondaryText = styled(BodyText)`
  margin: 0 0 ${({ theme }) => theme.spacings[7].rem};

  ${breakpoint('sm')`
    margin: ${({ theme: { spacings } }) =>
      `0 ${spacings[5].rem} ${spacings[7].rem} 0`};
  `}
`;

const Link = styled.span`
  color: ${({ theme }) => theme.typography.links.secondary.color};
  cursor: pointer;
`;

const CancelButton = styled(TertiaryButton)`
  min-width: 120px;
`;

export const HoldReserveModal: React.FC<HoldReserveModalProps> = ({
  isOpen,
  isButtonLoading,
  isSuccess,
  onAcceptBidLink,
  onHoldReserve,
  onClose,
}) => {
  const { title, body, successText } = useCMSData().modals.holdReserve;
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      isSuccess={isSuccess}
      successText={successText}
    >
      <PrimaryText size="lg">{body}</PrimaryText>
      <SecondaryText>
        If you change your mind later, you can also
        <Link onClick={onAcceptBidLink}> accept the current bid </Link>
        before the auction closes.
      </SecondaryText>
      <ButtonRow>
        <LoadingButton
          onClick={onHoldReserve}
          onClose={onClose}
          size="large"
          disabled={isButtonLoading}
          isLoading={isButtonLoading}
          isSuccess={isSuccess}
        >
          Hold reserve
        </LoadingButton>
        <CancelButton fullWidth={false} onClick={onClose} size="large">
          Cancel
        </CancelButton>
      </ButtonRow>
    </Modal>
  );
};
